import React, {ReactComponentElement} from "react";
import classes from './Gallery.module.scss'
import {GalleryView} from "./GalleryView";

function importAll(r: any) {
	return r.keys().map(r);
}

const images = importAll(require.context('../../images/picks', false, /\.(png|jpe?g|svg|webp)$/));

const Gallery = (): ReactComponentElement<any> => {

	return (
		<div className={classes.root}>
			<h2 style={{userSelect: "none"}}>Galerie</h2>
			<GalleryView>
				{images.map((item: any) => (
					<img src={item.default} alt={item.default} draggable="false"/>
				))}
			</GalleryView>
		</div>
	)
}

export default Gallery
